import { XCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { AlertProps } from './index';

export const DangerAlert: React.FC<Pick<AlertProps, 'label' | 'close'>> = props => {
  const { label, close } = props;
  return (
    <div className="relative flex items-center gap-3 rounded-md bg-red-50 p-4">
      <XCircleIcon className="size-6 flex-shrink-0 text-red-400" aria-hidden="true" />
      <p className="text-sm font-medium text-red-800">{label}</p>
      <button
        type="button"
        onClick={close}
        className="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
      >
        <span className="sr-only">Dismiss</span>
        <XMarkIcon className="size-5 flex-shrink-0" aria-hidden="true" />
      </button>
    </div>
  );
};

interface DangerAlertWithListProps extends Pick<AlertProps, 'label'> {
  children?: React.ReactNode;
  list: string[] | string;
}

export const DangerAlertWithList: React.FC<DangerAlertWithListProps> = props => {
  const { children, label, list } = props;
  const listItems: string[] = typeof list === 'string' ? [list] : [...list];
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-bold text-red-800">{label}</h3>
          <div className="mt-2 text-sm text-red-700">
            <ul role="list" className="list-disc space-y-1 pl-5">
              {listItems.map((item, index) => (
                <li key={index + item}>{item}</li>
              ))}
            </ul>
            <div className="pt-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
